import { Stack } from "@mui/material";
import { IMasterDataItem } from "src/api/server/wf-detail.types";
import { Typography } from "src/components-mui/base/typography/typography";
import { PopoverButtonIconInfo } from "src/components-mui/base/wf-popover/popover-button-icon-info";
import { WfPopover } from "src/components-mui/base/wf-popover/wf-popover";

type TMasterDataItemProps = IMasterDataItem<string>;

export const MasterDataItem = ({ label, value, tooltip }: TMasterDataItemProps) => (
    <Stack direction="row" sx={{ justifyContent: "space-between" }}>
        <Stack direction="row" sx={{ alignItems: "center" }}>
            {label}
            {tooltip && (
                <WfPopover
                    PopoverTrigger={<PopoverButtonIconInfo ariaLabel={label} sx={{ ml: 1 }} />}
                    content={tooltip.content}
                    link={tooltip.link}
                    slotProps={{ popper: { zIndex: 1 } }}
                />
            )}
        </Stack>
        <Typography sx={{ fontSize: "inherit", lineHeight: "inherit", fontWeight: "semibold" }}>{value}</Typography>
    </Stack>
);
